import Vue from 'vue'
import Router from 'vue-router'
import notFound from './page404';
import homeIndex from './homeIndex'//首页
import groupRouter from './group'//集团动态
import jobOffers from './jobOffers'//招贤纳士
import doctors from './doctors'//医生集团
import college from './college'//通策牙学院
import aboutUs from './aboutUs'//关于我们
Vue.use(Router)
const baseRouter = []
// 将所有路由串联起来
function combineRouter(routers) {
  return routers.reduce((a, b) => a.concat(b), baseRouter)
}

const pageRouters = [
  homeIndex,
  // 在这里写路由列表
  groupRouter,
  jobOffers,
  doctors,
  college,
  aboutUs
]
pageRouters.push(notFound);
const router = new Router({
  // 哈希模式
  mode: 'history',
  // 激活路由时,路由链接的类名
  linkActiveClassL: 'openActive',
  // 跳转到一个新页面时,定位到顶端  视情况可以删除
  scrollBehavior: () => ({
    y: 0
  }),
  routes: combineRouter(pageRouters)
})

// 路由发生变化修改页面title 
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.document.title = to.meta.title
  }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js